import { sanitizeHtml } from 'utils/sanitizeHtml'

export function writePrintWindow(printWindow, html, title = '') {
  if (!printWindow) {
    return false
  }

  const parser = new DOMParser()
  const safeHtml = sanitizeHtml(html)
  const parsedDoc = parser.parseFromString(
    `<!doctype html><html><head><title></title></head><body>${safeHtml}</body></html>`,
    'text/html'
  )
  parsedDoc.title = title || ''
  const targetDoc = printWindow.document

  targetDoc.documentElement.replaceWith(
    targetDoc.importNode(parsedDoc.documentElement, true)
  )

  return true
}
